import styled from 'styled-components';

export const DepartmentContainerStyled = styled.div`
  .show_loading {
    height: calc(100vh - 85px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
    .layer_one {
        display: flex;
    }
    .layer_two {
      margin-top: 51px;
    }
`;
